export function formatDate (datestring: string, locale: Intl.LocalesArgument = 'en', options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' }) {
  if (!datestring) return
  const date = new Date(datestring)
  return date.toLocaleDateString(locale, options)
}

export function getAssetURL (filepath: string): string {
  return new URL(`../assets/${filepath}`, import.meta.url).href
}

export function groupBy (data: Array<object>, key: string, options?: { fallbackGroup?: string | false, transformer?: (value: object) => unknown }) {
  const {
    fallbackGroup = 'default',
    transformer = (value: object) => value
  } = options || {}

  return data.reduce((acc, item) => {
    const group = typeof item[key] === 'string' ? item[key] : fallbackGroup
    if (group) {
      if (!acc[group]) acc[group] = []
      acc[group].push(transformer(item))
    }
    return acc
  }, {})
}

export function sleep (time: number) {
  return new Promise(resolve => setTimeout(resolve, time))
}

export function memoize (fn) {
  if (typeof fn !== 'function') {
    throw new Error('Memoization not allowed: the argument must be a function')
  }

  const cache = {}

  return function (...args) {
    const key = JSON.stringify(args)

    if (!cache.hasOwnProperty(key)) { // eslint-disable-line
      cache[key] = fn.apply(this, args)
    }

    return cache[key]
  }
}

export const toRomanNumeral = (input: number): string => {
  const romanNumeralMap = [
    ['M', 1000],
    ['CM', 900],
    ['D', 500],
    ['CD', 400],
    ['C', 100],
    ['XC', 90],
    ['L', 50],
    ['XL', 40],
    ['X', 10],
    ['IX', 9],
    ['V', 5],
    ['IV', 4],
    ['I', 1]
  ] as const

  return romanNumeralMap.reduce((acc, [key, value]) => {
    acc += key.repeat(Math.floor(input / value))
    input = input % value
    return acc
  }, '')
}

function fit (contain?: boolean) {
  return (parentWidth: number, parentHeight: number, childWidth: number, childHeight: number, scale = 1, offsetX = 0.5, offsetY = 0.5) => {
    const childRatio = childWidth / childHeight
    const parentRatio = parentWidth / parentHeight
    let width = parentWidth * scale
    let height = parentHeight * scale

    if (contain ? (childRatio > parentRatio) : (childRatio < parentRatio)) {
      height = width / childRatio
    } else {
      width = height * childRatio
    }

    return {
      width,
      height,
      offsetX: (parentWidth - width) * offsetX,
      offsetY: (parentHeight - height) * offsetY
    }
  }
}

export const getContainSize = fit(true)
export const getCoverSize = fit(false)
